var _rect, _circle, _circle2, _line, _circle3, _line2, _circle4, _rect2, _line3, _line4, _line5, _line6, _rect3, _circle5, _line7, _circle6, _line8, _circle7, _line9, _circle8, _line10, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 260,
    viewBox: "0 0 200 260",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 100,
    height: 100,
    rx: 20,
    ry: 20,
    fill: "#37474F",
    stroke: "#222",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 70,
    r: 10,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 70,
    r: 10,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 10,
    x2: 75,
    y2: 30,
    stroke: "#222",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 10,
    r: 6,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 10,
    x2: 125,
    y2: 30,
    stroke: "#222",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 10,
    r: 6,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 40,
    height: 10,
    fill: "white",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 112,
    x2: 120,
    y2: 112,
    stroke: "#00E5FF",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 116,
    x2: 120,
    y2: 116,
    stroke: "#00E5FF",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 114,
    x2: 85,
    y2: 118,
    stroke: "#00E5FF",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 114,
    x2: 115,
    y2: 118,
    stroke: "#00E5FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 80,
    height: 50,
    rx: 10,
    ry: 10,
    fill: "#263238",
    stroke: "#222",
    strokeWidth: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 10,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 150,
    x2: 20,
    y2: 160,
    stroke: "#003B46",
    strokeWidth: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 160,
    r: 6,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 150,
    x2: 180,
    y2: 160,
    stroke: "#003B46",
    strokeWidth: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 160,
    r: 6,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 180,
    x2: 80,
    y2: 220,
    stroke: "#222",
    strokeWidth: 6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 225,
    r: 10,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 180,
    x2: 120,
    y2: 220,
    stroke: "#222",
    strokeWidth: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 225,
    r: 10,
    fill: "#00E5FF",
    stroke: "#003B46",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.9192c78f6a24c4e955d5851a989052f1.svg";
export { ForwardRef as ReactComponent };